import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-7fce09ea"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "uploadWrap"
};
const _hoisted_2 = {
  class: "uploadInfo"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  class: "uploadText"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "格式：PNG/jpg", -1));
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "大小：3MB以下", -1));
const _hoisted_7 = {
  class: "uploadButton-normal"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("input", {
  class: "uploadInput",
  type: "file"
}, null, -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", {
    class: "uploadImage",
    style: _normalizeStyle({
      width: `${$props.width}px`,
      height: `${$props.height}px`
    })
  }, [_createElementVNode("img", {
    src: $data.imgurl,
    alt: ""
  }, null, 8, _hoisted_3)], 4), _createElementVNode("div", _hoisted_4, [_hoisted_5, _hoisted_6, _createElementVNode("div", _hoisted_7, [_createVNode(_component_el_button, null, {
    default: _withCtx(() => [_createTextVNode("上传 "), _hoisted_8]),
    _: 1
  })])])])]);
}